module.exports = __webpack_public_path__ + "static/media/dummy-image.57d487da.png";